// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Htf","left":"styles_left__z87K-","desktopActions":"styles_desktopActions__25sZX","title":"styles_title__MQ6O2"};